import { default as Vuex, Module } from "vuex";

class StatusBarModuleState {
	[key: string]: any;
	message: string = "Status messages will display here";
	gantryVoltage: string;
}

class StatusBar implements Module<StatusBarModuleState, any> {
	namespaced = true;
	state: StatusBarModuleState = new StatusBarModuleState();
	mutations = {
		SET_MESSAGE(state: StatusBarModuleState, payload: string) {
			state.message = payload;
		},
		SET_GANTRY_VOLTAGE(state: StatusBarModuleState, payload: string) {
			state.gantryVoltage = payload;
		}
	}
}

const statusBarModule: StatusBar = new StatusBar();

export default statusBarModule;
